/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import { BankAccount } from '../../../../apollo/fragments/BankAccount.gql';
import { CreditAppSavedSectionInfo } from '../../../../apollo/fragments/CreditAppSavedSectionInfo.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveManualBankAccount_updateCreditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_selectedBankInfo_BankInfo = { readonly __typename: 'BankInfo', readonly id: string | null, readonly accountHolderName: string | null, readonly accountNumberLength: number | null, readonly accountNumberLastFour: string | null, readonly bankName: string | null, readonly routingNumber: string | null, readonly source: _Types.CreditApplicationBankSource | null, readonly externalConnectionGuid: string | null, readonly logoUrl: string | null };

export type RemoveManualBankAccount_updateCreditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_bankInfo_BankInfo = { readonly __typename: 'BankInfo', readonly id: string | null, readonly accountHolderName: string | null, readonly accountNumberLength: number | null, readonly accountNumberLastFour: string | null, readonly bankName: string | null, readonly routingNumber: string | null, readonly source: _Types.CreditApplicationBankSource | null, readonly externalConnectionGuid: string | null, readonly logoUrl: string | null };

export type RemoveManualBankAccount_updateCreditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo = { readonly __typename: 'CreditApplicationFinanceInfo', readonly selectedBankInfo: RemoveManualBankAccount_updateCreditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_selectedBankInfo_BankInfo | null, readonly bankInfo: RemoveManualBankAccount_updateCreditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_bankInfo_BankInfo | null };

export type RemoveManualBankAccount_updateCreditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo = { readonly __typename: 'SavedSectionsInfo', readonly sectionName: _Types.SectionName, readonly completedAt: any | null, readonly completionStatus: _Types.CompletionStatus | null };

export type RemoveManualBankAccount_updateCreditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly financeInfo: RemoveManualBankAccount_updateCreditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo | null, readonly savedSectionsInfo: ReadonlyArray<RemoveManualBankAccount_updateCreditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo | null> | null };

export type RemoveManualBankAccount_Mutation = { readonly __typename: 'Mutation', readonly updateCreditApplication: RemoveManualBankAccount_updateCreditApplication_CreditApplication };


export type RemoveManualBankAccountVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
  financeInfo: _Types.FinanceInfoInput;
}>;


export type RemoveManualBankAccount = RemoveManualBankAccount_Mutation;


export const RemoveManualBankAccountDocument = gql`
    mutation RemoveManualBankAccount($creditApplicationId: ID!, $financeInfo: FinanceInfoInput!) {
  updateCreditApplication(
    creditApplicationId: $creditApplicationId
    financeInfo: $financeInfo
  ) {
    salesforceCreditId
    fetchedAt
    financeInfo {
      selectedBankInfo {
        ...BankAccount
      }
      bankInfo {
        ...BankAccount
      }
    }
    ...CreditAppSavedSectionInfo
  }
}
    ${BankAccount}
${CreditAppSavedSectionInfo}`;
export type RemoveManualBankAccountMutationFn = Apollo.MutationFunction<RemoveManualBankAccount, RemoveManualBankAccountVariables>;

/**
 * __useRemoveManualBankAccount__
 *
 * To run a mutation, you first call `useRemoveManualBankAccount` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveManualBankAccount` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeManualBankAccount, { data, loading, error }] = useRemoveManualBankAccount({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      financeInfo: // value for 'financeInfo'
 *   },
 * });
 */
export function useRemoveManualBankAccount(baseOptions?: Apollo.MutationHookOptions<RemoveManualBankAccount, RemoveManualBankAccountVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveManualBankAccount, RemoveManualBankAccountVariables>(RemoveManualBankAccountDocument, options);
      }
export type RemoveManualBankAccountHookResult = ReturnType<typeof useRemoveManualBankAccount>;
export type RemoveManualBankAccountMutationResult = Apollo.MutationResult<RemoveManualBankAccount>;
export type RemoveManualBankAccountMutationOptions = Apollo.BaseMutationOptions<RemoveManualBankAccount, RemoveManualBankAccountVariables>;